import {Component, Input, ViewEncapsulation} from '@angular/core';
import {AbstractControl, FormControl, NgModel} from '@angular/forms';

@Component({
    selector: 'app-input-field',
    templateUrl: './input-field.component.html',
    styleUrls: ['./input-field.component.scss',],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class InputFieldComponent {
  @Input() label: string;
  @Input() labelForErrorMessage: string;
  @Input('control') control: NgModel | FormControl;
  @Input() disabledStyle: boolean = false;
  @Input() highlightField = false;
  @Input() showLabel = true;
  @Input() showInfo = false;
  @Input() header: string;
  @Input() mainContent: string;
  @Input() isAbove =  true;
  @Input() isCentered =  false;
  @Input() marginValue =  0;

  showRequiredAsterisk: boolean = false;

  highlightFields() {
    return ((this.control?.touched || this.control?.dirty) && this.control?.errors) || this.highlightField;
  }

  ngOnInit() {
    this.fieldRequired();
  }


  fieldRequired() {
    if (this.control === undefined) {
      return false;
    }
    this.showRequiredAsterisk = this.control.validator?.({} as AbstractControl)?.required ?? false;
  }

}
